__turbopack_context__.v({
  "cookieConsent": "CookieConsent-module-scss-module__wFjJfG__cookieConsent",
  "hide": "CookieConsent-module-scss-module__wFjJfG__hide",
  "show": "CookieConsent-module-scss-module__wFjJfG__show",
});
